import { Modal, PrimaryButton, useForm, TextField } from '@weave/design-system';
import { useCreateNamespaceMutation } from 'apis/wetags/mutations';
import { namespacesListQuery } from 'apis/wetags/queriesV2';
import { useEffect } from 'react';

export const CreateNamespaceModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { mutateAsync } = useCreateNamespaceMutation();

  // reset the form on modal close
  useEffect(() => {
    if (!isOpen) {
      reset();
    }
  }, [isOpen]);

  const { formProps, getFieldProps, reset, values } = useForm({
    fields: {
      namespace: {
        type: 'text',
        required: true,
        minLength: 1,
        maxLength: 255,
        value: '',
      },
    },
    onSubmit: async (values) => {
      if (values.namespace) {
        try {
          await mutateAsync({
            id: values.namespace,
          } as any); // types are wrong
          // invalidate the list query to refresh
          // TODO fix passing pageSize to make it work
          namespacesListQuery.invalidate({ pageSize: 500 });
          reset();
          onClose();
        } catch (error) {}
      }
    },
  });

  return (
    <Modal show={isOpen} onClose={onClose}>
      <Modal.Header>Create New Namespace</Modal.Header>
      <br />
      <Modal.Body>
        <form {...formProps}>
          <TextField {...getFieldProps('namespace')} label="Name" required />
          <p>
            <small>Namespace ID must be globally unique.</small>
          </p>
          <PrimaryButton type="submit" disabled={!values.namespace}>
            Create
          </PrimaryButton>
        </form>
      </Modal.Body>
    </Modal>
  );
};
